import { buildRoutes } from '@/service/buildRoutes';

export function getTRCRedirectPath({ hasAccess, currentPath }) {
	const basePath = currentPath.startsWith('/studio-hub') ? '/studio-hub' : '/trc';

	if (!hasAccess) {
		return buildRoutes.toTRCAccess(basePath);
	}
	if (currentPath.endsWith('/access')) {
		return buildRoutes.toTRCHome(basePath);
	}
	return null;
}